import { inArray } from '@/shared/helpers';
import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import { indexOfAll } from '@/shared/helpers'

const filterOptions = (opts, term) => {
  if (!term) return opts;
  const lower = term.toLowerCase();
  return opts.reduce((acc, opt) => {
    const nameMatches = (opt.name || '').toLowerCase().includes(lower);
    const filteredChildren = filterOptions(opt.children || [], term);
    if (nameMatches || filteredChildren.length > 0) {
      acc.push({ ...opt, children: filteredChildren });
    }
    return acc;
  }, []);
};

export const CheckboxHierarchy = ({ name, fields, setFields, options, isRoot, isChildren, label, attr, searchable }) => {

  const [instanceKey, setInstanceKey] = useState(0)
  const handleReset = () => setInstanceKey(i => i + 1)

  const [isVisible, setIsVisible] = useState(false);
  const [search, setSearch] = useState('');
  const expand = () => {
    setIsVisible(!isVisible);
  };
  const close = () => {
    setIsVisible(false);
    setSearch('');
  }

  function useOutside(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          close();
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutside(wrapperRef);

  const findChildrenOptionId = (options, subOptions) => {
    for (let object of options) {
      subOptions.push(object[attr]);
      if (object.children && object.children.length) {
        return findChildrenOptionId(object.children, subOptions)
      }
    }
    return subOptions;
  }

  const toggleAll = (event, options) => {
    let tmpFields = fields;
    options.forEach((option) => toggleOption(tmpFields, option, event.target.checked));
    setFields(tmpFields);
  }

  const toggleOption = (tmpFields, opt, checked) => {
    const optionIndex = tmpFields.indexOf(opt[attr]);

    if (checked) {
      if (optionIndex === -1) {
        tmpFields.push(opt[attr]);
      }
      if (opt.children && opt.children.length) {
        opt.children.forEach((child) => toggleOption(tmpFields, child, checked));
      }
    } else {
      if (optionIndex !== -1) {
        tmpFields.splice(optionIndex, 1);
      }
      if (opt.children && opt.children.length) {
        opt.children.forEach((child) => toggleOption(tmpFields, child, checked));
      }
    }
  };

  const toggle = (event, option) => {
    let tmpFields = fields;
    toggleOption(tmpFields, option, event.target.checked);
    setFields(tmpFields);
  };

  const categoryClass = classNames({
    'checkbox-hierarchy': !isChildren,
    'children-checkbox-hierarchy': !!isChildren,
    'hierarchy_visible': isVisible,
    'checkbox-hierarchy-wrap': isRoot,
  });

  const visibleOptions = searchable && search ? filterOptions(options, search) : options;

  return (
    <>
      {isRoot ? (
        <div className={categoryClass} ref={wrapperRef}>
          <span className="lnr lnr-chevron-right" onClick={expand} onBlur={close} /> <span onClick={expand} style={{ cursor: 'pointer' }}
            className="form__form-group-label">{label}</span>
          <div className='array-wrap'>

            {searchable && (
              <input
                type="text"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search programs..."
                className="checkbox-hierarchy__search"
                onClick={e => e.stopPropagation()}
              />
            )}

            <div style={{ marginLeft: -6 }}><label className="checkbox-btn ">
              <input className="checkbox-btn__checkbox" type="checkbox" onClick={handleReset}
                onChange={event => toggleAll(event, options)} />
              <span className="checkbox-btn__checkbox-custom">
                <svg className="mdi-icon " width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z">
                  </path>
                </svg>
              </span>
              <span className="checkbox-btn__label">Select All</span>
            </label></div>

            {isVisible &&
              visibleOptions.map(option => (
                <CheckboxHierarchy key={'id-' + option[attr]} name={name} fields={fields} setFields={setFields}
                  toggle={toggle} options={[option]} attr={attr} />
              ))
            }
          </div>
        </div>
      ) : (
        options.map(option => (
          <div className={categoryClass} key={`checkbox-${option[attr]}`} style={{ whiteSpace: 'nowrap' }}>
            {option.children.length > 0 ? (
              <span className="lnr lnr-chevron-right" onClick={expand} />
            ) : (
              <span className="lnr" />
            )}
            <label className="checkbox-btn ">
              <input className="checkbox-btn__checkbox" name={name} type="checkbox" onClick={handleReset}
                onChange={event => toggle(event, option)}
                checked={inArray(option[attr], fields)} />
              <span className="checkbox-btn__checkbox-custom">
                <svg className="mdi-icon " width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z">
                  </path>
                </svg>
              </span>
              <span className="checkbox-btn__label">{option.name}</span>
            </label>
            {isVisible &&
              <CheckboxHierarchy key={instanceKey} name={name} fields={fields} setFields={setFields}
                options={option.children} isChildren={true} attr={attr} />
            }
          </div>
        ))
      )
      }
    </>
  )
}

export default CheckboxHierarchy;